import React from "react";

function LoadingSpinner() {
    return (
        <div  className="d-flex justify-content-center mt-5 mb-5">
            <div className="spinner-border text-primary" style={{width: "3.5rem", height: "3.5rem"}} role="status">
                <span className="visually-hidden">Laddar...</span>
            </div>
        </div>
    );
}

export default LoadingSpinner;
